import { useNavigate } from 'react-router-dom';

export default function Partners() {
  const navigate = useNavigate();

  const partners = [
    {
      name: '박성숙',
      business: '남도음식전문가',
      description: '전통 남도음식의 맛과 정성을 담은 치유 음식 체험',
      icon: 'ri-restaurant-line',
      image: 'https://public.readdy.ai/ai/img_res/793fb8d8e584052a300338befdd27827.jpg'
    },
    {
      name: '복영문',
      business: '제이앤비농장 (유자농장)',
      description: '고흥 특산 유자를 활용한 다양한 치유 프로그램',
      icon: 'ri-plant-line',
      image: 'https://readdy.ai/api/search-image?query=Korean%20yuzu%20citrus%20farm%2C%20organic%20yuzu%20trees%2C%20golden%20yuzu%20fruits%2C%20traditional%20Korean%20orchard%2C%20healing%20citrus%20garden%2C%20natural%20farming%2C%20therapeutic%20agriculture%2C%20peaceful%20farm%20setting&width=400&height=300&seq=yuzu-farm&orientation=landscape'
    },
    {
      name: '정종권',
      business: '봄햇살케어팜 (숲체험)',
      description: '자연 속에서 몸과 마음을 치유하는 숲 치유 프로그램',
      icon: 'ri-tree-line',
      image: 'https://static.readdy.ai/image/d1a0c06a8edb29d2039b650faf22b9bc/e1b5967c35fe028e68b5eb367eb7deee.jpeg'
    },
    {
      name: '최현귀',
      business: '두울리 (라벤더농장)',
      description: '라벤더의 향기로 마음의 평안을 찾는 아로마 치유',
      icon: 'ri-flower-line',
      image: 'https://readdy.ai/api/search-image?query=Purple%20lavender%20field%20in%20Korea%2C%20therapeutic%20lavender%20farm%2C%20aromatic%20healing%20garden%2C%20peaceful%20lavender%20rows%2C%20natural%20aromatherapy%20setting%2C%20healing%20herbs%2C%20serene%20purple%20flowers&width=400&height=300&seq=lavender-farm&orientation=landscape'
    },
    {
      name: '박지영',
      business: '세모실커피농장',
      description: '직접 재배한 커피로 만드는 특별한 커피 체험',
      icon: 'ri-cup-line',
      image: 'https://readdy.ai/api/search-image?query=Korean%20coffee%20farm%2C%20organic%20coffee%20plants%2C%20coffee%20bean%20cultivation%2C%20therapeutic%20coffee%20experience%2C%20natural%20coffee%20plantation%2C%20healing%20coffee%20garden%2C%20peaceful%20agricultural%20setting&width=400&height=300&seq=coffee-farm&orientation=landscape'
    },
    {
      name: '김은정',
      business: '한옥펜션',
      description: '전통 한옥에서 느끼는 고즈넉한 휴식과 치유',
      icon: 'ri-home-line',
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Korean%20hanok%20guesthouse%2C%20peaceful%20Korean%20architecture%2C%20healing%20accommodation%2C%20traditional%20Korean%20house%20with%20garden%2C%20serene%20hanok%20setting%2C%20therapeutic%20lodging%2C%20cultural%20healing%20space&width=400&height=300&seq=hanok-pension&orientation=landscape'
    },
    {
      name: '손현숙',
      business: '하루애꽃 (치유체험농장)',
      description: '다양한 꽃과 식물을 통한 원예 치유 프로그램',
      icon: 'ri-flower-fill',
      image: 'https://readdy.ai/api/search-image?query=Korean%20healing%20flower%20farm%2C%20therapeutic%20garden%20with%20colorful%20flowers%2C%20horticultural%20therapy%20setting%2C%20peaceful%20flower%20fields%2C%20healing%20plants%20and%20flowers%2C%20natural%20therapy%20garden&width=400&height=300&seq=flower-farm&orientation=landscape'
    }
  ];

  const handlePartnerClick = () => {
    navigate('/partners');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section id="partners" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-800 mb-6">참여업체 소개</h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            각각의 전문성을 가진 7개 농가가 함께 만드는 특별한 치유 경험을 만나보세요
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {partners.map((partner, index) => (
            <div 
              key={index} 
              onClick={handlePartnerClick}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative">
                <img
                  src={partner.image}
                  alt={`${partner.business} - ${partner.name}`}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute top-4 right-4 w-12 h-12 bg-white/90 rounded-full flex items-center justify-center">
                  <i className={`${partner.icon} text-green-600 text-xl`}></i>
                </div>
              </div>
              
              <div className="p-6">
                <h4 className="text-xl font-bold text-gray-800 mb-2">{partner.business}</h4>
                <p className="text-green-600 font-semibold mb-3">{partner.name} 님</p>
                <p className="text-gray-600 text-sm leading-relaxed">{partner.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}